import React from 'react'
import styles from './style.module.scss'
import bg from '../../assets/images/banner.png'

const RegisterLayout = ({ children }) => {
  return (
    <>
      <img src={bg} className={styles.bgImage} alt="" />
      <div className="container">
        <div className="row">
          <div className={`col-lg-10 offset-lg-1 ${styles.con}`}>{children}</div>
        </div>
      </div>
    </>
  )
}

export default RegisterLayout
